import Navbar from './components/Navbar';

import * as navbar from './ducks/navbar';

const components = {
    Navbar,
};

const ducks = {
    navbar,
};

export { components, ducks };
